import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatStatusAge, subscribeToLivePriceClock } from '../lib/livePriceUtils';

export default function StatusAge({ timestamp }) {
  const { t } = useTranslation();
  const [now, setNow] = useState(Date.now);
  useEffect(() => subscribeToLivePriceClock(setNow), []);

  return (
    <span className="block whitespace-normal text-[10px] font-normal tabular-nums text-gray-500" title={t('status_age_description')}>
      {formatStatusAge(timestamp, now)}
    </span>
  );
}
